<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 产品管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>产品列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.typeId" placeholder="请选择产品类型" @change="onChangeTypeId" filterable>
					<el-option key="" label="请选择产品类型" value=""></el-option>
					<el-option v-for="item in productTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-select v-model="query.seriesId" placeholder="请选择产品系列" filterable>
					<el-option key="" label="请选择产品系列" value=""></el-option>
					<el-option v-for="item in productSeriesKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.name" placeholder="产品型号" class="handle-input mr10"></el-input>&nbsp;
				<el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                @selection-change="handleSelectionChange"
				:cell-style="{padding:4+'px'}"
				stripe
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
				<el-table-column prop="name" label="产品型号" width = "230px">
					<template slot-scope="scope">{{scope.row.name + (scope.row.productNo?(" / " + scope.row.productNo):"")}}</template>
				</el-table-column>
                <el-table-column prop="typeId" label="类型" :formatter = "productTypeFormat" width = "200px"></el-table-column>
				<el-table-column prop="typeSeriesRemark" label="系列"></el-table-column>
				<el-table-column prop="hasReplace" label="状态" :formatter = "statusFormat" width = "100px"></el-table-column>
				<el-table-column prop="replaceName" label="替代型号" width = "230px"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleEdit(scope.$index, scope.row)"
							v-if="controll['edit']"
                        >编辑</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="warning"
                    icon="el-icon-delete"
                    class="handle-del mr10"
                    @click="delAllSelection"
					v-if="controll['delete-batch']"
                >批量删除</el-button>
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >添加记录</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="50%">
			<el-form ref="form" :model="form" label-width="150px" :rules="rules">
				<el-form-item label="产品类型" prop="typeId">
					<el-select v-model="form.typeId" placeholder="请选择产品类型" @change="onChangeTypeId" filterable>
						<el-option key="" label="请选择产品类型"></el-option>
						<el-option v-for="item in productTypeKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="产品系列" prop="seriesId">
					<el-select v-model="form.seriesId" placeholder="请选择产品系列" filterable>
						<el-option key="" label="请选择产品系列"></el-option>
						<el-option v-for="item in productSeriesKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-row>
					<el-col :span="12">
						<el-form-item label="产品型号" prop="name">
							<el-input v-model="form.name"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="产品货号" prop="productNo">
							<el-input v-model="form.productNo"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="是否停产被替代" prop="hasReplace">
							<el-radio-group v-model="form.hasReplace">
								<el-radio :label=false>在产</el-radio>
								<el-radio :label=true>停产</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="替代型号" prop="replaceName" v-if="form.hasReplace == true">
							<el-input v-model="form.replaceName"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="产地" prop="producer">
							<el-input v-model="form.producer"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="是否是虚拟产品" prop="virtualProduct">
							<el-switch v-model="form.virtualProduct"></el-switch>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="特点" prop="characteristic">
					<el-input type=textarea :rows=5 v-model="form.characteristic"> </el-input>
				</el-form-item>
			</el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
			
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchProductData, saveProduct, deleteProduct, getProduct, getEnumValueKV, getProductSeriesKV} from '../../../api/index';
export default {
    name: 'product',
    data() {
        return {
            query: {
				typeId:'',
				seriesId:'',
				name:'',
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
			productTypeEnumCode:1003,
			productTypeKV:{},
			productSeriesKV:{},
			title:"",
			rules: {
                name: [{ required: true, message: '系列名称不能为空', trigger: 'blur' }],
                typeId: [{ required: true, message: '请选择所属类型', trigger: 'blur' }],
				seriesId: [{ required: true, message: '请选择系列', trigger: 'blur' }],
				hasReplace: [{ required: true, message: '请选择状态', trigger: 'blur' }]
            },
			controll:{}
        };
    },
    created() {
		this.controll = getControll("product");
		this.getProductType();
        this.getData();
    },
    methods: {	
	    //产品类型格式化
		productTypeFormat(row, column, cellValue) {
			for (var i = 0; i < this.productTypeKV.length; i++) {
				if (this.productTypeKV[i].key === cellValue){
					return this.productTypeKV[i].value;
				}
			}
			return cellValue;
		},
		//产品系列格式化
		seriesFormat(row, column, cellValue) {
			for (var i = 0; i < this.productSeriesKV.length; i++) {
				if (this.productSeriesKV[i].key === cellValue){
					return this.productSeriesKV[i].value;
				}
			}
			return cellValue;
		},
		//获取产品类型
		getProductType() {
			getEnumValueKV(this.productTypeEnumCode).then(res => {
				if (res.code == 0 ) {
					this.productTypeKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//产品类型变更
		onChangeTypeId(value) {
			this.productSeriesKV = {};
			if (!value) {
				return;
			}
			getProductSeriesKV(value).then(res => {
				if (res.code == 0 ) {
					this.productSeriesKV = res.data;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
			});
		},
		//状态格式化
		statusFormat(row, column, cellValue) {
			if (typeof(cellValue) == undefined) return cellValue;
			return cellValue?"已停产":"在产"; 
		},
        // 获取 easy-mock 的模拟数据
        getData() {
            fetchProductData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteProduct([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
			if (length == 0) {
				this.$message.error(`请选择要删除的记录！`);
				return;
			}
            let ids = [];
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
				ids.push(this.multipleSelection[i].id)
            }
			this.$confirm('确定要删除选中的记录吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteProduct(ids).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
				})
				.catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.form = {};
			this.$set(this.form, "virtualProduct", "false")
			this.title = "添加新纪录";
			this.activeName = "baseTab";
			this.editVisible = true;
		},
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;
			this.title = "编辑";
			this.activeName = "baseTab";
			getProduct(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.onChangeTypeId(res.data.typeId);
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					this.form['typeSeriesRemark'] = this.seriesFormat('', '', this.form['seriesId']);
					saveProduct(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							if (typeof(this.form.id) == "undefined") {
								this.getData();
							} else {
								this.$set(this.tableData, this.idx, this.form);
							}
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
